{
  "version": 1,
  "asset_id": "6b1271a4-f498-4b7a-a1d0-be489d2ab5df",
  "project_id": "1820e758-46fa-46b0-bd5a-016534d0d263",
  "url": "/__l5e/assets-v1/6b1271a4-f498-4b7a-a1d0-be489d2ab5df/svc-analytics-reporting-1200.webp",
  "r2_key": "a/v1/1820e758-46fa-46b0-bd5a-016534d0d263/6b1271a4-f498-4b7a-a1d0-be489d2ab5df/svc-analytics-reporting-1200.webp",
  "original_filename": "svc-analytics-reporting-1200.webp",
  "size": 22226,
  "content_type": "image/webp",
  "created_at": "2026-07-25T02:26:42Z"
}
